import _ from 'lodash';
import axios from 'axios';
import { appApi, timeRefreshToken } from 'configs/variables';

export const checkTimeOutAccessToken = async (error, refreshTokenStatus) => {
  const findStatusCode = JSON.stringify(error).search('403');
  const findStatusCode401 = JSON.stringify(error).search('401');
  const networkErrorCode = JSON.stringify(error).search('Network Error');

  if (networkErrorCode >= 0) {
    return refreshTokenStatus;
  }

  if (findStatusCode >= 0 || findStatusCode401 >= 0) {
    if (!refreshTokenStatus) {
      const getParse = localStorage.getItem('user-store') || null;
      const userStore = JSON.parse(getParse);
      const checkTimeOut = checkTimeOutToken(userStore);
      if (userStore?.accessAuthen?.refresh_token && checkTimeOut) {
        refreshTokenStatus = true;

        await axios
          .post(`${appApi}/auth/refresh_token`, {
            refresh_token: userStore?.accessAuthen?.refresh_token,
          })
          .catch((error) => {
            console.log('err', error);
          })
          .then(function (response) {
            if (response?.status === 400 && response?.message === 'Refresh token is invalid.') {
              logOutPolice(userStore);
            } else {
              SetAccessAuth({ ...userStore?.accessAuthen, ...response?.data?.data });
            }
          })
          .finally(() => {
            refreshTokenStatus = false;
          });
      } else {
        logOutPolice(userStore);
      }
    }
  }
  return refreshTokenStatus;
};

async function logOutPolice(userStore = null) {
  const payload = {
    access_token: _.get(userStore?.accessAuthen, 'access_token', ''),
    ip: localStorage.getItem('app_ip') || '',
  };
  await axios
    .post(`${appApi}/auth/logout_police`, payload)
    .catch((error) => {
      console.log('err', error);
    })
    .finally(() => {
      localStorage.removeItem('user-store');
      window.location.reload();
    });
}

export const checkTimeOutToken = (userStore) => {
  if (!_.isEmpty(userStore)) {
    const currentDate = new Date();
    const toMiliTime = currentDate.getTime();
    return toMiliTime > (userStore?.accessAuthen?.expires_at || 0);
  } else {
    return false;
  }
};

export const SetAccessAuth = (accessAuthen = null) => {
  if (!_.isEmpty(accessAuthen)) {
    console.log('accessAuthen', accessAuthen);
    const signDate = new Date();
    signDate.setSeconds(signDate.getSeconds() + _.get(accessAuthen, 'expires_in', timeRefreshToken));
    accessAuthen.expires_at = signDate.getTime();
    const userLocalStore = localStorage.getItem('user-store') || {};
    const userLocalStoreJSON = JSON.parse(userLocalStore);
    userLocalStoreJSON.accessAuthen = accessAuthen;
    axios.defaults.headers.common.Authorization = accessAuthen?.access_token;
    if (userLocalStoreJSON) {
      localStorage.setItem('user-store', JSON.stringify(userLocalStoreJSON));
    }
  }
};
